"use client"

import React, {useEffect, useState} from 'react';
import {getFirstURISegment} from "@/utility/uriSegment.utility";
import Breadcrumbs from "@/components/common/BreadCrumb";
import Post2 from '@/components/common/post/Post2';
import PageHeader from "@/components/common/page-header";

function Page({params}) {
    const [url, setUrl] = useState(null);
    useEffect(() => {
        let url = getFirstURISegment() + "/" + params.post;
        setUrl(url)
    }, [])
    const paths = [{name: "TRANG CHỦ", url: "/"}, {name: "GÓC CHIA SẺ KINH NGHIỆM"}];
    return (
        <>
            <PageHeader title="Góc chia sẻ kinh nghiệm" />
            <div className="container-fluid" style={{marginTop: "20px"}}>
                <Breadcrumbs paths={paths}/>
            </div>
            {url ? <Post2 url={url}/> : ""}
        </>
    );
}

export default Page;